import { NavLink } from 'react-router-dom';
import { formatDate, IconInfo } from '@ui/src';
import getStatusClassName from '../../helpers/get-status-class-name';
import getApplicationStatus from '../../helpers/get-status-name';
import { NewApplicationStatus, ReviewStatus } from '../../types';
import { NewApplicationTopBaseInfoTypes } from '../types';

import cn from '../styles.module.css';

const NewApplicationTopBaseInfo = ({
  newApplicationInfo,
  statusChangeError,
}: NewApplicationTopBaseInfoTypes) => {
  const { reviewStatusText, statusClassName } = getStatusClassName({
    status: newApplicationInfo?.status as NewApplicationStatus,
    reviewStatus: newApplicationInfo?.reviewStatus,
  });

  return (
    <div className={cn.newApplicationBaseInfo}>
      <div className={`${cn.newApplicationBaseInfoItem} ${statusClassName}`}>
        {`${newApplicationInfo?.status ? getApplicationStatus(newApplicationInfo?.status) : 'Incomplete'}
                 ${
                   newApplicationInfo?.reviewStatus ===
                   ReviewStatus.HAS_DUPLICATE
                     ? `(${reviewStatusText})`
                     : ''
                 }
                  `}
      </div>
      <div className={cn.newApplicationBaseInfoItem}>
        {formatDate(newApplicationInfo?.createdAt as string, true)}
        <div
          className={cn.newApplicationBaseInfoItemHint}
          data-text="Date created"
        >
          <IconInfo width={18} height={18} />
        </div>
      </div>
      {newApplicationInfo?.applicationScheme && (
        <NavLink
          to={`/settings/scheme/${newApplicationInfo?.applicationScheme?.id}`}
          target="_blank"
          className={cn.newApplicationBaseInfoItem}
        >
          {newApplicationInfo?.applicationScheme.name}
          <div
            className={cn.newApplicationBaseInfoItemHint}
            data-text="Application Scheme"
          >
            <IconInfo width={18} height={18} />
          </div>
        </NavLink>
      )}
      {statusChangeError && (
        <div className={cn.statusChangeError}>{statusChangeError}</div>
      )}
    </div>
  );
};

export default NewApplicationTopBaseInfo;
